//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { TableRow } from '@components/organisms/table/TableRow';

import { PrepaidPurchaseOptionsTableRowContent } from './PrepaidPurchaseOptionsTableRowContent';

interface PrepaidPurchaseOptionsTableRowReadOnlyProps {
  purchaseOption: PurchaseOption;
}

export const PrepaidPurchaseOptionsTableRowReadOnly = ({
  purchaseOption,
}: PrepaidPurchaseOptionsTableRowReadOnlyProps) => {
  return (
    <TableRow>
      <PrepaidPurchaseOptionsTableRowContent purchaseOption={purchaseOption} />
    </TableRow>
  );
};
